import { api } from "@/hooks/axios-api";
import { useQuery } from "@tanstack/vue-query";
import { computed, Ref, unref } from "vue";

const fetchEnrolledHealthSeekers = async (applicableYear?: string) => {
  const response = await api.get("/tools/enrolled-memberships/");
  return response.data;
};

const fetchHealthSeekerById = async (id: string) => {
  // const response = await api.get(`/tools/health-seekers/${id}/`);
  const response = await api.get(`/tools/memberships/client/${id}/`);
  return response.data;
};

///////////////////// HOOKS ////////////////////////////

export const useFetchEnrolledHealthSeekers = () =>
  useQuery({
    queryKey: ["enrolledHealthSeekers"],
    queryFn: () => fetchEnrolledHealthSeekers(),
    // refetchInterval: 3000
    refetchOnWindowFocus: true,
  });

export const useFetchHealthSeekerById = (id: string | Ref<string | null>) =>
  useQuery({
    queryKey: computed(() => ["healthSeeker", unref(id)]),
    queryFn: () => fetchHealthSeekerById(unref(id)),
    refetchOnWindowFocus: false,
    enabled: computed(() => !!unref(id)), // Only fetch if id is provided
  });
